import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { usePqrReceptionChannelForm } from './hook';
import { PqrReceptionChannelData } from './data';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    PQR_RECEPTION_CHANNEL,
    PQR_RECEPTION_CHANNEL_DETAIL,
    PQR_RECEPTION_CHANNEL_EDIT,
    PQR_RECEPTION_CHANNEL_NEW,
} from '../../../../../routes/paths';
import { PqrReceptionChannelParamsHistorical } from '../historical';

export const PqrReceptionChannelForm = () => {
    const {
        pqrReceptionChannel,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikPqrReceptionChannelData,
        pqrReceptionChannelHistorical,
        showHistorical,
        setShowHistorical,
    } = usePqrReceptionChannelForm();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    pqrReceptionChannel && pqrReceptionChannel.id
                        ? 'Editar canal de recepción PQR'
                        : 'Crear canal de recepción PQR'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={pqrReceptionChannel?.id || ''}
                        buttonCreate={{
                            show: Boolean(pqrReceptionChannel?.id),
                            route: PQR_RECEPTION_CHANNEL_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PQR_RECEPTION_CHANNEL,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: PQR_RECEPTION_CHANNEL_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: PQR_RECEPTION_CHANNEL_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(pqrReceptionChannel?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <PqrReceptionChannelParamsHistorical
                        historical={pqrReceptionChannelHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <PqrReceptionChannelData
                data={pqrReceptionChannel}
                onChangeFormik={(formik) =>
                    setFormikPqrReceptionChannelData(formik)
                }
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
